import { createI18n } from 'vue-i18n';
import { client } from '@/api/client.gen.ts';
import { determineLocale } from '@/utilities';
import frCa from '@/locales/fr-CA/locale.json';
import enCa from '@/locales/en-CA/locale.json';
import type { Ref } from 'vue';

type MessageSchema = typeof frCa;

export type LOCALES = 'en-CA' | 'fr-CA';

export const OPPOSITE_LOCALE: Record<LOCALES, LOCALES> = {
  'en-CA': 'fr-CA',
  'fr-CA': 'en-CA',
};

function updateLocale(locale: LOCALES) {
  (i18n.global.locale as unknown as Ref<LOCALES>).value = locale;

  client.interceptors.request.use((config) => {
    config.headers.set('Accept-Language', locale);
    return config;
  });
}

export async function setLocale() {
  const locale = determineLocale();

  if (i18n.global.locale !== locale) {
    updateLocale(locale);
  }
}

const initialLocale = determineLocale();

const i18n = createI18n<[MessageSchema], 'fr-CA' | 'en-CA'>({
  locale: initialLocale,
  legacy: false,
  messages: {
    'fr-CA': frCa,
    'en-CA': enCa,
  },
});

updateLocale(initialLocale);

export default i18n;
